import React, { useMemo } from "react";
import PropTypes from "prop-types";
import StyleMatchProvider from "../provider/index.js";
import useQuiz from "../../hooks/useQuiz.js";
function Quiz(_ref) {
  var facetFilterCounterUrl = _ref.facetFilterCounterUrl,
    filterRankSlugs = _ref.filterRankSlugs,
    pathFragment = _ref.pathFragment,
    specificSlugForFacetMapping = _ref.specificSlugForFacetMapping,
    fashionUrl = _ref.fashionUrl,
    children = _ref.children;
  var _useQuiz = useQuiz({
      facetFilterCounterUrl: facetFilterCounterUrl,
      filterRankSlugs: filterRankSlugs,
      pathFragment: pathFragment,
      specificSlugForFacetMapping: specificSlugForFacetMapping,
      fashionUrl: fashionUrl
    }),
    step = _useQuiz.step,
    stepNumber = _useQuiz.stepNumber,
    maxStepNumber = _useQuiz.maxStepNumber,
    loading = _useQuiz.loading,
    nextAvailable = _useQuiz.nextAvailable,
    maxSelected = _useQuiz.maxSelected,
    redirectUrl = _useQuiz.redirectUrl,
    select = _useQuiz.select,
    nextStep = _useQuiz.nextStep,
    finish = _useQuiz.finish;
  var contextValue = useMemo(function () {
    return {
      step: step,
      stepNumber: stepNumber,
      maxStepNumber: maxStepNumber,
      loading: loading,
      nextAvailable: nextAvailable,
      maxSelected: maxSelected,
      redirectUrl: redirectUrl,
      select: select,
      nextStep: nextStep,
      finish: finish
    };
  }, [step, stepNumber, maxStepNumber, loading, nextAvailable, maxSelected, redirectUrl, select, nextStep, finish]);
  return /*#__PURE__*/React.createElement(StyleMatchProvider, {
    value: contextValue
  }, children);
}
process.env.NODE_ENV !== "production" ? Quiz.propTypes = {
  facetFilterCounterUrl: PropTypes.string.isRequired,
  filterRankSlugs: PropTypes.arrayOf(PropTypes.string).isRequired,
  pathFragment: PropTypes.string.isRequired,
  specificSlugForFacetMapping: PropTypes.shape({}).isRequired,
  fashionUrl: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
} : void 0;
export default Quiz;